import { request } from '../auth/client';
import type { ProviderSlug, UsageRow } from '@runik/shared';

export interface UsageFilters {
  customerId?: string;
  providerSlug?: ProviderSlug;
  from?: string; // ISO datetime
  to?: string; // ISO datetime
}

export const usageKey = (filters: UsageFilters = {}) => ['usage', filters] as const;

function buildParams(filters: UsageFilters): string {
  const params = new URLSearchParams();
  if (filters.customerId) params.set('customerId', filters.customerId);
  if (filters.providerSlug) params.set('providerSlug', filters.providerSlug);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function listUsage(filters: UsageFilters = {}) {
  return request<UsageRow[]>(`/api/usage${buildParams(filters)}`);
}

export function refreshUsage(filters: UsageFilters = {}) {
  // Refresh sadece provider/customer scope alır; from/to backend'de zaten 30 gün backfill.
  const refreshFilters: UsageFilters = {
    customerId: filters.customerId,
    providerSlug: filters.providerSlug,
  };
  return request<{ status: string; queued: number }>(
    `/api/usage/refresh${buildParams(refreshFilters)}`,
    { method: 'POST' },
  );
}
